require("@rails/ujs").start();
require("turbolinks").start();
require("@rails/activestorage").start();
require("channels");
require("bootstrap");

import debounced from "debounced";
debounced.initialize({ input: { wait: 200 } });

// CSS
import "blissfuljs"; // doc: https://blissfuljs.com/docs.html
import "normalize.css";
import "typeface-montserrat";
import "stylesheets/backoffice";
import "@stimulus/polyfills";
import "controllers";
import "@fortawesome/fontawesome-free/js/all.js";
